import { Box, Text } from '@chakra-ui/react';
import React from 'react';

import { finleyBuffer } from '@finley-technologies/common';
import { generateTapeDefinitionFromCSV } from '@finley-technologies/tape-sanitizer';

import { ConfigureParams } from './types';
import { convertErrorToStringMessages } from '../calcAgentQA/convertErrorToStringMessages';
import { FileUploadButton } from '../calcAgentQA/FileUploadButton';

type Props = {
  onAutoConfigure: (params: ConfigureParams) => void;
};
export const AutoConfigureSanitizePanel = ({ onAutoConfigure }: Props) => {
  return (
    <Box mb="2">
      <Text mb="2">Generate config from Sample CSV</Text>
      <FileUploadButton
        allowedExtensions={['csv', 'xlsx', 'pdf', 'txt']}
        buttonText="Upload Tape"
        handleFile={async (arrayBuffer: ArrayBuffer) => {
          try {
            const {
              sanitizedFieldNames: _unused,
              ...tapeDefinition
            } = await generateTapeDefinitionFromCSV({
              buffer: finleyBuffer.fromArrayBuffer(arrayBuffer),
            });
            onAutoConfigure({
              isValid: true,
              operation: 'sanitize',
              configuration: { operation: 'sanitize', ...tapeDefinition },
            });
          } catch (e) {
            // eslint-disable-next-line no-console
            console.error('Error generating configuration:', e);
            const errors = convertErrorToStringMessages(e);
            onAutoConfigure({
              isValid: false,
              operation: 'sanitize',
              errors,
            });
          }
        }}
      />
    </Box>
  );
};
